import { Button as MaterialButton, IconButton as MaterialIconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

export const ButtonContainer = styled.div`
  button:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledMaterialButton = styled(
    ({
         children, type, margin, ...props
     }) => {
        let colorProp = props.color || 'primary';
        if (type === 'danger') {
            colorProp = 'error';
        } else if (['primary', 'secondary', 'success', 'info', 'warning'].includes(type)) {
            colorProp = type;
        }

        const buttonProps = { ...props };
        delete buttonProps.type;

        return <MaterialButton {...buttonProps} color={colorProp}>{children}</MaterialButton>;
    }
)`
  ${props => props.margin && css`
    margin: ${props.margin} !important;
  `}

  &:hover {
    ${props => props.type === 'danger' && css`
      color: var(--error-color);
    `}
  }
`;

const StyledMaterialIconButton = styled(
    ({
         children, type, ...props
     }) => {
        let colorProp = props.color || 'primary';
        if (type === 'danger') {
            colorProp = 'error';
        } else if (['primary', 'secondary', 'success', 'info', 'warning'].includes(type)) {
            colorProp = type;
        }

        const buttonProps = { ...props };
        delete buttonProps.type;

        return <MaterialIconButton {...buttonProps} color={colorProp}>{children}</MaterialIconButton>;
    }
)`
  &:hover {
    ${props => props.type === 'danger' && css`
      color: var(--error-color);
    `}
  }
`;

export const Button = ({
                           children, ...props
                       }) => (
                         <StyledMaterialButton {...props}>
                           {children}
                         </StyledMaterialButton>
);

export const IconButton = ({
                               children, ...props
                           }) => (
                             <StyledMaterialIconButton {...props}>
                               {children}
                             </StyledMaterialIconButton>
);

Button.propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool,
    margin: PropTypes.string,
    variant: PropTypes.string
};

Button.defaultProps = {
    disabled: false,
    margin: '',
    type: 'primary',
    variant: 'contained'
};

IconButton.propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool
};

IconButton.defaultProps = {
    disabled: false,
    type: 'primary'
};
